import { render } from "./RntrcSolicitacao.vue?vue&type=template&id=0b3af76d"
import script from "./RntrcSolicitacao.vue?vue&type=script&lang=ts"
export * from "./RntrcSolicitacao.vue?vue&type=script&lang=ts"
script.render = render

export default script